export const incubatorTablePage = (): boolean => {
    const {pathname} = window.location;
    const incubatorLineId = /\/play\/incubator\/(?<id>\d+)/u;

    return Boolean(pathname.includes('/play/incubator')) &&
        !pathname.match(incubatorLineId) && !pathname.match('play/incubator/my_lines');
};
